import React from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectIsLebtItemPoliciesEnabled } from 'businessTraveller/selectors/itemPolicy/selectIsLebtItemPoliciesEnabled'
import BusinessTravellerStickyBudgetBar from './BusinessTravellerStickyBudgetBar'
import BusinessTravellerItemPolicyStickyBudgetBar from './BusinessTravellerItemPolicyStickyBudgetBar'

interface Props {
  checkInDate?: string
  checkOutDate?: string
  roomCount?: number
  className?: string
  offer?: App.AnyOffer
}

// Temporary switch while legacy and item-policy hotel budget bars run side by side behind lebt_item_policies_enabled.
function BusinessTravellerAccommodationBudgetBarSwitch(props: Props) {
  const isItemPoliciesEnabled = useAppSelector(selectIsLebtItemPoliciesEnabled)

  if (isItemPoliciesEnabled) {
    return <BusinessTravellerItemPolicyStickyBudgetBar {...props} />
  }

  return <BusinessTravellerStickyBudgetBar {...props} />
}

export default BusinessTravellerAccommodationBudgetBarSwitch
